var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClicks2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.188,16.264,11.014,8.758a.418.418,0,0,0-.682.323v12.51a.417.417,0,0,0,.764.231L14.309,17h5.615a.417.417,0,0,0,.264-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.294,2.464A7.09,7.09,0,0,0,8.2,15.7a.437.437,0,0,0,.15.028.418.418,0,0,0,.15-.807,6.255,6.255,0,1,1,8.084-3.592.417.417,0,1,0,.778.3A7.1,7.1,0,0,0,13.294,2.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.941,7.219A4.587,4.587,0,1,0,9.1,13.363a.436.436,0,0,0,.15.027.417.417,0,0,0,.149-.806,3.754,3.754,0,1,1,4.851-2.155.417.417,0,0,0,.778.3A4.551,4.551,0,0,0,14.941,7.219Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicks2);
export default __webpack_public_path__ + "static/media/clicks_2.1bc0f34b554112ddf5a4633f623565ba.svg";
export { ForwardRef as ReactComponent };